import React from 'react';
import tw from 'twin.macro';
import { ChevronRightIcon as ChevronRight } from '@heroicons/react/24/outline';

export type BreadcrumbDividerIcon = 'dot' | 'chevron';
interface Props {
  children: React.ReactNode;
  showIcon?: boolean;
  dividerIcon?: BreadcrumbDividerIcon;
}

export function BreadcrumbItem(props: Props) {
  const { children, showIcon, dividerIcon = 'chevron' } = props;
  // We don't shrink the first element
  return (
    <li css={[tw`grow min-w-0`, !showIcon && tw`flex-shrink-0`]}>
      <div tw="flex items-center min-w-0">
        {showIcon && dividerIcon === 'dot' && (
          <div tw="hidden md:flex shrink-0 flex justify-start">
            <div tw="bg-neutral-quiet size-1.5 rounded-full" />
          </div>
        )}
        {showIcon && dividerIcon === 'chevron' && (
          <ChevronRight tw="shrink-0 text-neutral-quiet h-5 w-5" />
        )}
        <div
          css={[
            tw`grow cursor-pointer text-sm min-w-0`,
            showIcon && tw`md:ml-2.5`,
          ]}
        >
          {children}
        </div>
      </div>
    </li>
  );
}
